import { config } from 'config';
import { checkAccessFactory } from 'utils/checkAccessFactory';

export const checkAccessIsB2B = checkAccessFactory(() => Boolean(config.isB2B), 'not_found');
